// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1LuDP","consentsList":"PatientConsents_consentsList__3Wjse","consentsListEmpty":"PatientConsents_consentsListEmpty__3wUSa"};